// extracted by mini-css-extract-plugin
module.exports = {"footer-banner-section-accordion":"FooterBannerSectionAccordion_footer-banner-section-accordion__lJ2PS"};